import React, { ReactElement, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { LoaderButton } from 'idsk-react-components';
import { useUserContext } from '../../../context/UserContext';
import Secured from '../../Secured';
import UserRole from '../../../model/currentuser/UserRole';
import exportIcon from '../icons/export.svg';
import { useSecurityContext } from '../../../context/SecurityContext';
import { useErrorMessageContext } from '../../../context/ErrorMessageContext';
import downloadFile from '../../../function/downloadFile';
import { exportVyhodnotenieMpkReport } from '../../../client/exportVyhodnotenieMpkReportClient';
import useFilterFromUrl from '../../Filter/hook/useFilterFromUrl';
import emptyFilter from '../../PripomienkaList/emptyFilter';

interface Props {
  setOpenDropdown: (isOpen: boolean) => void;
  buttonName: string;
  useFilter?: boolean;
  isHromadna?: boolean;
  existOdoslana?: boolean;
}

const NahladVyhodnoteniaPkButton = ({
  setOpenDropdown,
  buttonName,
  useFilter = false,
  isHromadna,
  existOdoslana = false,
}: Props): ReactElement => {
  const { legislationProcess } = useUserContext();
  const [disabled, setDisabled] = useState<boolean>(false);
  const { displayError } = useErrorMessageContext();
  const { accessToken, organizationId } = useSecurityContext();
  const headers = {
    ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
    ...(organizationId && { OrganizationId: encodeURIComponent(organizationId) }),
  };

  const filter = useFilterFromUrl();
  const updatedFilter = {
    ...filter,
    typ: isHromadna ? ['hromadna'] : filter.typ,
  };

  const downloadExport = async (): Promise<void> => {
    setDisabled(true);

    exportVyhodnotenieMpkReport(
      {
        materialUuid: legislationProcess.legMaterialUuid,
        nahladVyhodnotenia: true,
        useFilter,
        filterRequest: useFilter ? updatedFilter : emptyFilter,
      },
      { headers },
    ).then((response) => {
      downloadFile(response.data.fileName, response.data.blob);
      setDisabled(false);
      if (setOpenDropdown) {
        setOpenDropdown(false);
      }
    }).catch(async error => {
      setDisabled(false);
      if (error.response.status === 404) {
        const errorText = await error.response.data.text();
        displayError(errorText);
      } else if (error.response.status !== 200) {
        displayError('Z technických príčin nebolo možné vykonať požadovanú akciu. Skúste neskôr.');
      }
    });
  };

  return (
    <Secured allowForRoles={[UserRole.VYHODNOCOVATEL, UserRole.SUPERADMIN]}>
      {useFilter ? (
        <LoaderButton
          className="export-pripomienok-button-filter"
          size="large"
          buttonStyle="primary"
          type="submit"
          onClick={downloadExport}
          loading={disabled}
          disabled={!existOdoslana}
        >
          {buttonName}
        </LoaderButton>
      ) : (
        <li key="Náhľad pre vyhodnotenie PK" className="action-item">
          <div className="icon-wrapper">
            <img
              src={exportIcon}
              className="icon"
              alt="Náhľad pre vyhodnotenie PK"
            />
          </div>
          <button
            disabled={disabled}
            type="button"
            className="export-pripomienok-button button-inline-text idsk-link"
            onClick={downloadExport}
          >{buttonName}{disabled ? (
            <FontAwesomeIcon
              className="spinner"
              icon={faSpinner}
              spin
            />
          ) : null}
          </button>
        </li>
      )}
    </Secured>
  );
};

export default NahladVyhodnoteniaPkButton;
